var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("questionnaire-edit-section-group", {
        attrs: {
          model: _vm.roomTypesModel,
          preview: _vm.preview,
          template: _vm.groupTemplate,
        },
      }),
      _c("div", [
        _c("div", { staticClass: "questionnaireEditTableHeader" }, [
          _c("span", { staticClass: "questionnaireEditTableHeaderText" }, [
            _vm._v(_vm._s(_vm.tableTemplate.name) + " Table"),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "questionnaireEditTableContainer",
            class: _vm.tableTemplate.classes,
          },
          [
            !_vm.preview
              ? _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "rb-buttons small main",
                      on: {
                        click: function ($event) {
                          return _vm.configureRateGrid()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("grid_on"),
                      ]),
                      _vm._v(" Configure "),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "layout-row" }, [
              _c("div", { staticClass: "questionnaireEditTableWrapper" }, [
                _c(
                  "table",
                  { staticClass: "questionnaireEditTable" },
                  _vm._l(_vm.cellsToView, function (cell) {
                    return _c("questionnaire-table-row", {
                      key: cell.id,
                      attrs: { template: cell, model: _vm.tableConfig },
                    })
                  }),
                  1
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }